import React, { ReactNode } from 'react'
import styled, { css } from 'styled-components'

import Box from '@components/Box'

import { above } from '@styles/mixins/breakpoints'

const SScrollBlock = styled.div`
  width: 100%;
  overflow-x: auto;
  padding-bottom: 20px;

  ${above('md')(css`
    overflow-x: visible;
    padding-bottom: 0;
  `)}
`

const SWrap = styled.div`
  position: relative;
  width: 764px;
  padding-right: 20px;

  ${above('md')(css`
    width: 100%;
    padding-right: 0;
  `)}
`

interface IProps {
  backgroundComponent?: ReactNode
}

const HowItWorks: React.FC<IProps> = ({ children, backgroundComponent }) => {
  return (
    <SScrollBlock>
      <SWrap>
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          position="relative"
          flexDirection={{ _: 'row', md: 'column', xl: 'row' }}
          zIndex={1}
        >
          {children}
        </Box>
        {backgroundComponent || ''}
      </SWrap>
    </SScrollBlock>
  )
}

export default HowItWorks
